module.exports = __webpack_public_path__ + "img/headerBg.c23a5f2e.png";